<template>
	<div class="seller">
		<SellerList />
	</div>
</template>
<script>
	import SellerList from '../../components/brand/SellerList.vue';

	export default {
		components: {
			SellerList,
		},
	};
</script>
<style lang="scss" scoped></style>
